export const getChapters = (state) => state?.timeline?.chapters;

export const getTimeInMinutes = (state) =>
  state?.timeline?.timeline?.durationInMinutes;

export const getTimelineLoading = (state) => state?.timeline?.loading;

export const getSlidesFromTimeline = (state) => {
  let slides = [];
  state?.timeline?.timeline?.chapters?.forEach((chapter) =>
    slides.push(chapter?.slides)
  );

  return slides.flat();
};

export const getChapterStep = (state) => state?.timeline?.chapterStep;

export const getCurrentChapter = (state) => state?.timeline?.currentChapter;

export const getChapterSlideStep = (state) =>
  state?.timeline?.currentChapter?.step;
